import { CommanderFunction } from "../../contexts/commander";
import { Command } from "../../constants/types/commands";

type QueuedCommand = { type: Command; payload: unknown };

export const queueCommander = (
    sendCommand: CommanderFunction,
): CommanderFunction => {
    const commands: QueuedCommand[] = [];
    setInterval(() => {
        if (!commands.length) return;
        const { type, payload } = commands.shift()!;
        sendCommand(type, payload);
    }, 0);
    return (type: Command, payload: unknown) => {
        commands.push({ type, payload });
    };
};
